import { WindowHelper } from '../WindowHelper';

export default class ProjectSorter {
    isAnActiveProject(node, textFilter) {
        return (node.getAttribute(this.filter).indexOf(textFilter) > -1) || (['All', 'Alle', 'Tous', 'Tutti'].indexOf(textFilter) > -1);
    }

    differentFromDisplayAll(textFilter) {
        return !(['All', 'Alle', 'Tous', 'Tutti'].indexOf(textFilter) > -1);
    }

    activateProjectFromSelectedItem() {
        this.filterTouch.addEventListener('change', () => {
            this.activateProjectItem(this.filterTouch.value);
        }, true);
    }

    hideAllProjectItems() {
        for (let i = 0; i < this.listItemNodes.length; i++) {
            this.listItemNodes[i].classList.add('is-hidden-sorted-item');
            this.listItemNodes[i].classList.remove('has-sorted-padding');
        }
    }

    activateProjectItem(textFilter) {
        this.hideAllProjectItems();
        let activeI = 0;
        for (let i = 0; i < this.listItemNodes.length; i++) {
            if (this.isAnActiveProject(this.listItemNodes[i], textFilter)) {
                this.listItemNodes[i].classList.remove('is-hidden-sorted-item');

                if (activeI % 2 === 0) this.listItemNodes[i].classList.add('has-sorted-padding');

                activeI++;
            }
        }
    }

    eventActivateSelected() {
        for (let i = 0; i < this.filterItemNodes.length; i++) {
            this.filterItemNodes[i].addEventListener('click', () => {
                this.activateProjectItem(this.filterItemNodes[i].innerText);
            }, true);
        }
    }

    constructor(filterContainerNodeQS) {
        if (WindowHelper.isElementThere(filterContainerNodeQS)) {
            this.filter = document.querySelector(filterContainerNodeQS).getAttribute('data-filter');
            this.filterItemNodes = document.querySelectorAll(`${filterContainerNodeQS} .is-project-list-item`);
            this.filterTouch = document.querySelector(filterContainerNodeQS).nextElementSibling.nextElementSibling;
            this.listItemNodes = document.querySelectorAll('.project-item');
        }
    }
}
